import React from 'react'

export default function FieldSelectField_FormValueEmpty(props:any) {

    const placeholder = props.field.noValueOption ? props.field.noValueOptionLabel : props.field.placeholder

    const classes = Classes("ui5-field-form-editable dropdown-form h-36", props.className)

    const placeholderClasses = Classes('txt-truncate', {
        'ui5-txt-no-accent-default' : !props.field.noValueOption,
        'ui5-txt-default'           : !!props.field.noValueOption,
    })

    return (
        <>
            <div className={classes} onClick={props.onClick}>
                {/*{_.get(props.field.components, 'ValueIcon', false)}*/}
                {!!props.field.noValueOptionIcon &&
                    <div className={Classes("ui5-ico-15 m-r-8", props.field.noValueOptionIcon)}/>}
                <div className={placeholderClasses}>{placeholder}</div>
            </div>
            {props.children}
        </>
    )
}
